const PAYEE_MISMATCH_EXPLANATION_TYPE = {
  BANK_REFERENCE_LETTER: {
    value: "bank_reference_letter",
    readableName: "Bank Reference letter",
  },
  EMAIL_CONFIRMATION: {
    value: "email_confirmation",
    readableName: "Email Confirmation",
  },
  SUPPORTING_KYC: {
    value: "supporting_kyc",
    readableName: "Supporting KYC",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

// Convert the object to an array of entries
export const payeeMistmatchExplanationTypeArray = Object.values(
  PAYEE_MISMATCH_EXPLANATION_TYPE,
);
